import { call, put, takeLatest } from "redux-saga/effects";
import { httpSaveGeneratedQuestions } from "../../../services/questions";
import {
  saveGeneratedQuestionStart,
  saveGeneratedQuestionSuccess,
  saveGeneratedQuestionFailure,
} from "../reducer";
import { successNotifier } from "../../../utils/helpers";
import { networkErrorHandler } from "../../../utils/errorHandlers";

export function* saveGeneratedQuestions({ payload }) {
  const { data, callback } = payload;
  const response = yield call(httpSaveGeneratedQuestions, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(saveGeneratedQuestionSuccess(raw));
    successNotifier(`Question(s) saved successfully`);
    if (callback) {
      callback();
    }
  } else {
    yield put(saveGeneratedQuestionFailure(message || raw));
    networkErrorHandler(response.statusCode, message || raw);
  }
}

export default function* onSaveGeneratedQuestions() {
  yield takeLatest(saveGeneratedQuestionStart.type, saveGeneratedQuestions);
}
